import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import DetailIcon from '../ui/DetailIcon';
import InfoFact from '../ui/InfoFact';

// One timezone on the server and in the browser, including English pages.
export const formatDateTime = (iso, locale) =>
  new Intl.DateTimeFormat(locale === 'ro' ? 'ro-RO' : 'en-GB', {
    dateStyle: 'long', timeStyle: 'short', timeZone: 'Europe/Bucharest',
  }).format(new Date(iso));

export default function DropFacts({ drop, columns = false }) {
  const { t, locale } = useTranslation('drop');
  return <dl className={columns ? 'grid gap-4 xl:grid-cols-2' : 'space-y-4 sm:space-y-5'}>
    <InfoFact plain={columns} icon={<DetailIcon name="calendar" />} label={t('facts.deadline')}>
      {drop.registrationEndsAt ? <time dateTime={drop.registrationEndsAt}>{formatDateTime(drop.registrationEndsAt, locale)}</time> : t('facts.noDeadline')}
    </InfoFact>
    <InfoFact plain={columns} icon={<DetailIcon name="users" />} label={t('facts.access')}>{t(`access.${drop.access}`)}</InfoFact>
  </dl>;
}
